var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-style',{staticClass:"widget-content",style:({overflow: _vm.isShowBackgroundImageBlur? 'hidden': ''}),attrs:{"bg":_vm.bg,"mobile-bg":_vm.mobileBg,"custom-style":_vm.customStyle}},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }